import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { EMPTY_LIST } from '../../../../../constants/common'
import { QA_NAME_CONFIRMATION } from '../../../../../constants/qa'
import { useScreen } from '../../../../../hooks'
import { ConfirmationModal } from '../../../../Confirmation'
import { PostTypeSelectFormikField } from '../../../../Post'
import { NEWSBOARD_POST_FORM_FIELD_NAME_TYPE } from '../../NewsboardPostForm.constants'

function PostTypeField({
  resetInitialValues,
  setFiles,
  setModal,
  setStorageFiles,
  onCloseModal,
}) {
  const { t } = useTranslation()

  const { dirty, resetForm, values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  function handleChangeType(value) {
    setFiles(EMPTY_LIST)
    setStorageFiles(EMPTY_LIST)

    resetForm({
      values: {
        ...resetInitialValues,
        [NEWSBOARD_POST_FORM_FIELD_NAME_TYPE]: value,
      },
    })

    onCloseModal()
  }

  function getNextValue(value) {
    const typeChanged =
      value.value !== values[NEWSBOARD_POST_FORM_FIELD_NAME_TYPE].value

    if (!typeChanged) {
      return value
    }

    if (dirty) {
      setModal(
        <ConfirmationModal
          actionButtonsProps={{
            cancelText: t('Modal.CommonGoBackBtnKey'),
            submitText: t('Modal.CommonChangeBtnKey'),
          }}
          description={t('Modal.ChangePostTypeConfirmationTextKey')}
          qaName={QA_NAME_CONFIRMATION}
          onCancel={onCloseModal}
          onSubmit={() => handleChangeType(value)}
        />
      )

      return values[NEWSBOARD_POST_FORM_FIELD_NAME_TYPE]
    }

    handleChangeType(value)

    return value
  }

  return (
    <PostTypeSelectFormikField
      controlProps={{
        borderless: !isMobileScreenSize,
        contentProps: {
          inputProps: {
            placeholder: t('Newsboard.PostTypePlaceholderKey'),
          },
        },
        indicatorsProps: {
          ButtonClear: null,
        },
      }}
      fieldComponentProps={{
        label: `${t('Newsboard.TypeLabelKey')}:`,
        required: true,
        shouldAdaptToMobileScreen: true,
      }}
      getNextValue={getNextValue}
      name={NEWSBOARD_POST_FORM_FIELD_NAME_TYPE}
    />
  )
}

export default PostTypeField
